import React from "react";
import moment from "moment";
import { useRecordContext } from "react-admin";

export const TimeField = ({ source }) => {
  const record = useRecordContext();
  return <div>{moment(record[source]).fromNow()}</div>;
};
